import { TrashIcon } from "outline-icons";
import * as React from "react";
import { MenuItem } from "../../../shared/editor/types";

// export default function tableMenuItems(dictionary: Dictionary): MenuItem[] {
  export default function tableMenuItems(): MenuItem[] {

  return [
    {
      name: "deleteTable",
      tooltip: "Delete table",
      icon: <TrashIcon />,
      active: () => false,
    },
  ];
}
